import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Skeleton loading state for project cards in the dashboard
 * Matches the layout of the recent projects list items
 */
export const ProjectCardSkeleton: React.FC = () => {
  return (
    <div className="flex items-center justify-between p-2 rounded border">
      <div className="flex items-center gap-2 flex-1">
        <Skeleton className="h-4 w-4 rounded" />
        <Skeleton className="h-4 w-32" />
      </div>
    </div>
  );
};

/**
 * Multiple skeleton cards for loading state
 */
export const ProjectCardSkeletonList: React.FC<{ count?: number }> = ({
  count = 3,
}) => {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <ProjectCardSkeleton key={i} />
      ))}
    </div>
  );
};
